import { httpClient } from '../httpClient';
import {
  IImageGeneration,
  CreateImageGenerationRequest,
  UpdateImageGenerationRequest,
  PaginatedResponse,
  ImageGenerationQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户图片编辑 API 模块
 * 处理用户图片编辑管理操作
 */
export class ImageEditApi {
  /**
   * 获取用户图片编辑分页列表（POST，强类型）
   */
  async imageEditPageList(queryData: PaginationQuery<ImageGenerationQuery>): Promise<PaginatedResponse<IImageGeneration>> {
    return httpClient.post<PaginatedResponse<IImageGeneration>>('/user/imageEdits/page', queryData);
  }

  /**
   * 创建图片编辑任务
   */
  async createImageEdit(data: CreateImageGenerationRequest): Promise<IImageGeneration> {
    return httpClient.post<IImageGeneration>('/user/imageEdits', data);
  }

  /**
   * 获取图片编辑任务详情
   */
  async getImageEdit(id: string): Promise<IImageGeneration> {
    return httpClient.get<IImageGeneration>(`/user/imageEdits/${id}`);
  }

  /**
   * 更新图片编辑任务
   */
  async updateImageEdit(id: string, data: UpdateImageGenerationRequest): Promise<IImageGeneration> {
    return httpClient.put<IImageGeneration>(`/user/imageEdits/${id}`, data);
  }

  /**
   * 取消图片编辑任务
   */
  async cancelImageEdit(id: string): Promise<void> {
    return httpClient.post<void>(`/user/imageEdits/${id}/cancel`);
  }

  /**
   * 删除图片编辑任务
   */
  async deleteImageEdit(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/imageEdits/${id}`);
  }
}

// 导出单例实例
export const imageEditApi = new ImageEditApi();